// Javascript library CSS override
require("./public/css/jquery.bxslider.scss");

// Custom JS && CSS
require("./_common/js/hapi-lazy.js");
require("./_common/js/hapi-background-slides.js");
require("./_common/js/hapi-background-video.js");
require("./_common/js/hapi-page-extra.js");

require("./_common/js/input-type-number.js");
require("./_common/js/input-type-number.scss");

require("./_common/js/hapi-gridcell-popmenu.js");
require("./_common/js/hapi-gridcell-popmenu.scss");

require("./public/js/gridlayout-support-detection.js");

require("./public/js/scrollAction.js");
require("./public/js/scrollAction.css");

require("./public/js/scrolled.js");
require("./public/js/scrollReveal.js");

require("./public/js/parallax.js");

//require("./public/js/cookieDirective.js");

require("./public/js/fullscreen_content_panel.js");

require("./public/js/extra_analytics.js");

require("./public/js/helpers.js");

// Script additionnel de compensation pour la grille RWD
require('./_common/css/grille_rwd.js');

require("./public/js/automatic-backlink.js");

// Module CSS and JS will be loader by the PHP assets loaders
